import { render, staticRenderFns } from "./TurnstilesArchive.vue?vue&type=template&id=76276f4c&scoped=true"
import script from "./TurnstilesArchive.vue?vue&type=script&lang=js"
export * from "./TurnstilesArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76276f4c",
  null
  
)

export default component.exports